import { render, staticRenderFns } from "./EstruturaPaiTabela.vue?vue&type=template&id=0cb60c45&lang=html"
import script from "./EstruturaPaiTabela.vue?vue&type=script&lang=js"
export * from "./EstruturaPaiTabela.vue?vue&type=script&lang=js"
import style0 from "./EstruturaPaiTabela.vue?vue&type=style&index=0&id=0cb60c45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports